// Base64 encode value
function encodeString(string: string) {
    return window.btoa(string);
}

// Decode base64 encodedValue
function decodeString(encodedString: string) {
    return window.atob(encodedString);
}

export { encodeString, decodeString };
